module.exports = __webpack_public_path__ + "img/ja.ed444d8a.svg";